import type { Channel, ContentPieceDetail, PieceKind, PieceStatus, PublicationItem } from '../../shared/api/types';

export const KIND: Record<PieceKind, string> = { article: 'Artículo', sermon: 'Predicación', study: 'Estudio' };
export const STATUS: Record<PieceStatus, { label: string; tone: string }> = {
  draft: { label: 'Borrador', tone: '' },
  in_review: { label: 'En revisión', tone: 'badge--pending' },
  approved: { label: 'Aprobado', tone: 'badge--active' },
  archived: { label: 'Archivado', tone: '' },
};
export const EVENT: Record<ContentPieceDetail['events'][number]['action'], string> = {
  created: 'Creó la pieza',
  edited: 'Guardó una versión',
  submitted: 'Envió a revisión',
  approved: 'Aprobó',
  returned: 'Pidió cambios',
  archived: 'Archivó',
  restored: 'Restauró',
};
export const CHANNEL: Record<Channel, string> = { church: 'Iglesia', public: 'Página pública' };
export const PUBLICATION_STATE: Record<PublicationItem['state'], { label: string; tone: string }> = {
  published: { label: 'Publicada', tone: 'badge--active' },
  scheduled: { label: 'Programada', tone: 'badge--pending' },
  withdrawn: { label: 'Retirada', tone: '' },
};

/** Texto plano en párrafos (sin HTML: lo escrito nunca se interpreta como código). */
export const paragraphs = (body: string) => body.split(/\n\s*\n/).map((p) => p.trim()).filter(Boolean);
